export function lerp(start, end, amt){
    return (1 - amt) * start + amt * end
}

export function clamp( value, min, max ){
    return value < min ? min: value > max ? max : value
}

export function map(value, x1, y1, x2, y2) {
    return (value - x1) * (y2 - x2) / (y1 - x1) + x2
}